<template>
  <transition name="fade">
    <div class="pnlDialogFull" v-if="show" style="animation-duration: 0.3s">
      <div class="pnlDialogGray">
        <!-- @click.self="CloseDialog" -->
        <div class="pnlDialogAdminSetting">
          <div class="pnlTitleBar">
            <label>{{ school }}</label>
            <img class="btnDialogXX" src="@/assets/img/icon_btn/btn_close.png" @click="CloseDialog" />
          </div>
          <div class="pnlTab">
            <div :class="currentTab == 'Info' ? 'tabItemSelect' : 'tabItemUnSelect'" @click="SelectTab('Info')">
              主帳號
            </div>
            <div :class="currentTab == 'Child' ? 'tabItemSelect' : 'tabItemUnSelect'" @click="SelectTab('Child')">
              使用帳號
            </div>
            <div :class="currentTab == 'Lectures' ? 'tabItemSelect' : 'tabItemUnSelect'" @click="SelectTab('Lectures')">
              課程
            </div>
            <div :class="currentTab == 'Machine' ? 'tabItemSelect' : 'tabItemUnSelect'" @click="SelectTab('Machine')">
              裝置
            </div>
          </div>
          <div v-show="currentTab == 'Info'" class="pnlContent">
            <template v-if="accountData.info != null">
              <div class="InfoTitle">名稱</div>
              <div class="InfoContent">{{ accountData.info.name }}</div>
              <div class="InfoTitle">帳號</div>
              <div class="InfoContent">{{ accountData.info.account }}</div>
              <div class="InfoTitle">可用語系</div>
              <div class="InfoContent">{{ accountData.info.lang }}</div>
              <div class="InfoTitle">預設語系</div>
              <div class="InfoContent">{{ accountData.info.defaultLang }}</div>
              <div class="InfoTitle">國家</div>
              <div class="InfoContent">{{ accountData.info.nation }}</div>
              <div class="InfoTitle">縣市</div>
              <div class="InfoContent">{{ accountData.info.county }}</div>
              <div class="InfoTitle">學校</div>
              <div class="InfoContent">{{ accountData.info.school }}</div>
              <div class="InfoTitle">VCMS授權到期日</div>
              <div class="InfoContent">
                <label v-show="!isEditVcmsTime" class="lectureExpire">{{ accountData.info.vcmstime }}</label>
                <button
                  v-show="!isEditVcmsTime"
                  class="editIcon"
                  @click="ShowEditVcmsTime(accountData.info.vcmstime)"
                ></button>
                <datepicker
                  v-show="isEditVcmsTime"
                  v-model="vcmsTime"
                  format="YYYY-MM-DD"
                  value-type="format"
                  placeholder="Select date"
                  class="editVcms"
                ></datepicker>
              </div>
              <div class="pnlBtnArea" v-show="isEditVcmsTime">
                <button class="btnAddConfirm" @click="EditVcmsTime()">儲存</button>
                <button class="btnAddCancel" @click="CloseEditVcmsTime()">取消</button>
              </div>
            </template>
          </div>
          <div v-show="currentTab == 'Child'" class="pnlContent scrollBar">
            <div class="childItem" style="pointer-events: none">
              <div class="childName">名稱</div>
              <div class="childAccount">帳號</div>
            </div>
            <div style="clear: both"></div>
            <div class="pnlChildScrollArea">
              <div class="childItem" v-for="item in accountData.child" :key="item.serial">
                <div class="childName">{{ item.name }}</div>
                <div class="childAccount">{{ item.account }}</div>
              </div>
            </div>
          </div>
          <div v-show="currentTab == 'Lectures'" class="pnlContent scrollBar">
            <div class="lectureItem" style="pointer-events: none">
              <div class="lectureName">課程</div>
              <div class="lectureExpire">期限</div>
              <div class="lectureStatus">狀態</div>
            </div>
            <div style="clear: both"></div>
            <div class="pnlLectureScrollArea">
              <div class="lectureItem" v-for="item in accountData.lectures" :key="item.serial">
                <div class="lectureName">{{ item.name }}</div>
                <div v-show="item.serial != editLectureSerial" class="lectureExpire">{{ item.expire }}</div>
                <!-- <datepicker
                  v-show="item.serial == editLectureSerial"
                  format="yyyy-MM-dd"
                  v-model="editLectureExpire"
                  class="editExpire"
                  :readonly="false"
                  @closed="OnExpireSelectChange"
                ></datepicker> -->

                <datepicker
                  v-show="item.serial == editLectureSerial"
                  v-model="editLectureExpire"
                  format="YYYY-MM-DD"
                  value-type="format"
                  placeholder="Select date"
                  class="editExpire"
                ></datepicker>

                <div class="lectureStatus">{{ ClacLectureStatus(item) }}</div>
                <button v-show="item.serial != editLectureSerial" class="lectureEdit" @click="EditLecture(item)">
                  編輯
                </button>
                <!-- <div v-show="item.serial != editLectureSerial" class="lectureStop" @click="StopLecture(item)">停權</div> -->
                <button v-show="item.serial == editLectureSerial" class="doneEdit" @click="DoneEditLecture(item)">
                  完成
                </button>
                <button v-show="item.serial == editLectureSerial" class="cancelEdit" @click="CancelEditLecture()">
                  取消
                </button>
              </div>
            </div>
            <div class="pnlLectureAdd" @click="ShowAddLecture()">
              <img class="imgLectureAdd" src="@/assets/img/icon_btn/icon_add.png" />新增
            </div>
          </div>
          <div v-show="currentTab == 'Machine'" class="pnlContent scrollBar">
            <div class="machineItem" style="pointer-events: none">
              <div class="machineSerial">編號</div>
              <div class="machineId">裝置序號</div>
              <div class="machineDes">裝置名稱</div>
            </div>
            <div style="clear: both"></div>
            <div class="pnlMachineScrollArea">
              <div class="machineItem" v-for="item in accountData.machine" :key="item.serial">
                <div class="machineSerial">{{ item.serial }}</div>
                <div v-show="item.serial != editMachineSerial" class="machineId">{{ item.id }}</div>
                <div v-show="item.serial != editMachineSerial" class="machineDes">{{ item.des }}</div>
                <button v-show="item.serial != editMachineSerial" class="machineEdit" @click="EditMachine(item)">
                  編輯
                </button>
                <button v-show="item.serial != editMachineSerial" class="machineDel" @click="ShowDelMachine(item)">
                  刪除
                </button>
                <input
                  v-show="item.serial == editMachineSerial"
                  @keyup.esc="CancelEditMachine()"
                  class="editId"
                  v-model="editMachineId"
                  maxlength="20"
                  type="text"
                />
                <input
                  v-show="item.serial == editMachineSerial"
                  @keyup.esc="CancelEditMachine()"
                  class="editDes"
                  v-model="editMachineDes"
                  maxlength="8"
                  type="text"
                />
                <button v-show="item.serial == editMachineSerial" class="doneEdit" @click="DoneEditMachine(item)">
                  完成
                </button>
                <button v-show="item.serial == editMachineSerial" class="cancelEdit" @click="CancelEditMachine()">
                  取消
                </button>
              </div>
            </div>
            <div class="pnlMachineAdd">
              <img class="imgLectureAdd" src="@/assets/img/icon_btn/icon_add.png" />匯入
              <input
                type="file"
                id="fileMachine"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                class="fuClass"
                @change="UploadMachineFile"
              />
            </div>
            <div class="pnlMachineAddExample" @click="DownloadMachineExample()">匯入範例下載</div>
          </div>
        </div>
      </div>
      <DialogTwoBtn
        :show="dialogDelMachine.isShow"
        :title="dialogDelMachine.title"
        :content="dialogDelMachine.content"
        :btnRightText="dialogDelMachine.btnRightText"
        :btnLeftText="dialogDelMachine.btnLeftText"
        @close-dialog="CloseDelMachineDialog"
        @btn-right-click="DelMachine"
        @btn-left-click="CloseDelMachineDialog"
      />
      <DialogAddLecture
        :show="dialogAddLecture.isShow"
        :serial="dialogAddLecture.serial"
        :lecture="accountData.lectures"
        :account="dialogAddLecture.account"
        @close-dialog="CloseAddLectureDialog"
        @add-lecture="AddLecture"
        @btn-right-click="CloseAddLectureDialog"
        @btn-left-click="CloseAddLectureDialog"
      />
      <DialogOneBtn
        :show="dialogMsg.isShow"
        :msgWarning="dialogMsg.msg"
        :btnTxt="dialogMsg.btnTxt"
        @btn-click="CloseMsgDialog"
      />
      <Loading
        :active.sync="loadingInfo.isLoading"
        :can-cancel="false"
        :is-full-page="true"
        :color="loadingInfo.color"
        :opacity="loadingInfo.opacity"
        :background-color="loadingInfo.bgColor"
      ></Loading>
    </div>
  </transition>
</template>
<script>
import DialogTwoBtn from '@/components/Dialog/DialogTwoBtn.vue';
import DialogAddLecture from '@/components/Dialog/DialogAddLecture.vue';
import DialogOneBtn from '@/components/Dialog/DialogOneBtn.vue';
import datepicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {
  apiGetAccountDetail,
  apiAdminEditCourse,
  apiAdminEditMachine,
  apiDelAdminMachine,
  apiImportAdminMachine,
  apiUpdateVcmsTime,
} from '@/request.js';

export default {
  name: 'DialogAdminSetting',
  props: {
    show: Boolean,
    serial: Number,
    school: String,
  },
  data() {
    return {
      loadingInfo: {
        isLoading: false,
        color: '#fff',
        opacity: 0.9,
        bgColor: '#131217',
      },
      dialogDelMachine: {
        isShow: false,
        title: '注意',
        content: '',
        btnRightText: this.$t('ClassSetting.BtnDel'),
        btnLeftText: this.$t('ClassSetting.BtnCancel'),
      },
      dialogAddLecture: {
        isShow: false,
        serial: -1,
        account: '',
      },
      dialogMsg: {
        isShow: false,
        msg: '',
        btnTxt: '',
      },
      currentTab: 'Info', //Info, Child, Lectures, Machine
      editLectureSerial: -1,
      editLectureExpire: '',
      test: '2020-06-30',
      editMachineSerial: -1,
      editMachineId: '',
      editMachineDes: '',
      delMachineSerial: -1,
      accountData: {},
      isEditVcmsTime: false,
      vcmsTime: '',
    };
  },
  watch: {
    show(val) {
      if (val) {
        // this.accountData = {
        //   info: {
        //     name: 'Name@#$@&',
        //     account: 'school_123456@gmail.com',
        //     lang: 'zh-TW, en-US',
        //     defaultLang: 'zh-TW',
        //     nation: '台灣',
        //     county: '高雄市',
        //     school: '民權國小',
        //   },
        //   child: [
        //     { serial: 0, name: 'A老師', account: 'teacher_aaaaa@gmail.com' },
        //     { serial: 1, name: 'B老師', account: 'teacher_bbbbb@gmail.com' },
        //   ],
        //   lectures: [
        //     { serial: 3, name: '教具酷', expire: '2021-06-30' },
        //     { serial: 10, name: '單字找找看-辦公室', expire: '2020-05-07' },
        //     { serial: 19, name: '物質進出細胞膜', expire: '2021-02-01' },
        //   ],
        //   machine: [
        //     { serial: 0, id: '1PAS0KHJ123123', des: '3123' },
        //     { serial: 1, id: '1PAS0KHJasdass', des: 'dass' },
        //     { serial: 2, id: '1PAS0KHJ123333', des: '3333' },
        //     { serial: 3, id: '1PAS0KHJaaaaaa', des: 'efdf' },
        //     { serial: 4, id: '1PAS0KHJasdbbb', des: 'ddss' },
        //     // { serial: 5, id: '1PAS0KHJ127ccc', des: 'fff' },
        //     // { serial: 6, id: '1PAS0KHJ123eee', des: 'cccc' },
        //     // { serial: 7, id: '1PAS0KHJasdfff', des: 'ccec' },
        //     // { serial: 8, id: '1PAS0KHJ127ggg', des: 'fdsf' },
        //     // { serial: 9, id: '1PAS0KHJ123hhh', des: 'cvbb' },
        //     // { serial: 10, id: '1PAS0KHJasdiii', des: 'h6jg' },
        //     // { serial: 11, id: '1PAS0KHJ127jjj', des: '65ut' },
        //     // { serial: 12, id: '1PAS0KHJ123kkk', des: '7iyu' },
        //     // { serial: 13, id: '1PAS0KHJasdlll', des: 'ghj9' },
        //     // { serial: 14, id: '1PAS0KHJ127mmm', des: '1345' },
        //   ],
        // };

        let data = { serial: this.serial };
        apiGetAccountDetail(data).then((res) => {
          if (res.data != null) {
            //console.log(JSON.stringify(res.data));
            this.accountData = res.data.info;
          } else {
            this.accountData = {};
          }
        });
      } else {
        this.accountData = {};
      }
    },
  },
  methods: {
    CloseDialog() {
      this.$emit('close-dialog');
    },
    CloseMsgDialog() {
      this.dialogMsg.isShow = false;
    },
    SelectTab(tab) {
      this.currentTab = tab;
    },
    ClacLectureStatus(item) {
      if (item.expire == null || item.expire == '') {
        return '停用';
      } else {
        let dtExpire = new Date(item.expire + ' 23:59:59');
        let dtNow = new Date();
        if (dtExpire >= dtNow) {
          return '使用中';
        } else {
          return '已到期';
        }
      }
    },
    EditLecture(item) {
      this.editLectureSerial = item.serial;
      this.editLectureExpire = item.expire;
    },
    StopLecture(item) {
      item;
    },
    CancelEditLecture() {
      this.editLectureSerial = -1;
      this.editLectureExpire = '';
    },
    DoneEditLecture(item) {
      let patchExpire = this.editLectureExpire == null ? '' : this.editLectureExpire;

      let data = {
        expire: patchExpire,
        account: this.accountData.info.account,
      };
      //console.log(`DoneEditLecture data ${JSON.stringify(data)}`);
      apiAdminEditCourse(item.serial, data).then((res) => {
        //console.log(res.data);
        if (res.data != null && res.data.status == 'ok') {
          this.$toasted.show(`修改完成`, {
            icon: 'check',
            position: 'bottom-center',
            duration: 2500,
          });
        }
      });
      item.expire = this.editLectureExpire;
      this.CancelEditLecture();
    },
    ShowAddLecture() {
      //console.log(this.serial);
      this.dialogAddLecture.serial = this.serial;
      this.dialogAddLecture.account = this.accountData.info.account;
      this.dialogAddLecture.isShow = true;
    },
    CloseAddLectureDialog() {
      this.dialogAddLecture.isShow = false;
    },
    AddLecture(data) {
      this.accountData.lectures.push(data);
    },
    EditMachine(item) {
      this.editMachineSerial = item.serial;
      this.editMachineId = item.id;
      this.editMachineDes = item.des;
    },
    CancelEditMachine() {
      this.editMachineSerial = -1;
      this.editMachineId = '';
      this.editMachineDes = '';
    },
    DoneEditMachine(item) {
      let data = {
        serial: item.serial,
        id: this.editMachineId,
        des: this.editMachineDes,
      };
      apiAdminEditMachine(data).then((res) => {
        //console.log(JSON.stringify(res.data));
        if (res.data != null && res.data.status == 'ok') {
          item.id = this.editMachineId;
          item.des = this.editMachineDes;
          this.CancelEditMachine();
          this.$toasted.show(`修改完成`, {
            icon: 'check',
            position: 'bottom-center',
            duration: 2500,
          });
        } else {
          this.$toasted.show(`錯誤, ${JSON.stringify(res.data)}`, {
            icon: 'warning',
            position: 'bottom-center',
            duration: 2500,
          });
        }
      });
    },
    ShowDelMachine(item) {
      this.delMachineSerial = item.serial;
      this.dialogDelMachine.isShow = true;
      this.dialogDelMachine.content = `確定要刪除 ${item.id} (${item.des}) ?`;
    },
    CloseDelMachineDialog() {
      this.delMachineSerial = -1;
      this.dialogDelMachine.isShow = false;
    },
    DelMachine() {
      apiDelAdminMachine(this.delMachineSerial).then((res) => {
        //console.log(JSON.stringify(res.data));
        if (res.data != null && res.data.Status == 'ok') {
          let indexOf = this.accountData.machine.findIndex((obj) => obj.serial == this.delMachineSerial);
          this.accountData.machine.splice(indexOf, 1);
          this.CloseDelMachineDialog();
          this.$toasted.show(`刪除成功`, {
            icon: 'check',
            position: 'bottom-center',
            duration: 2500,
          });
        } else {
          this.$toasted.show(`錯誤, ${JSON.stringify(res.data)}`, {
            icon: 'warning',
            position: 'bottom-center',
            duration: 2500,
          });
        }
      });
    },
    UploadMachineFile(event) {
      let postforms = new FormData();
      postforms.append('file', event.target.files[0]);
      this.loadingInfo.isLoading = true;
      apiImportAdminMachine(this.accountData.info.account, postforms).then((res) => {
        //console.log(JSON.stringify(res.data));
        this.loadingInfo.isLoading = false;
        if (res.data != null && res.data.status == 'ok') {
          this.accountData.machine = this.accountData.machine.concat(res.data.machine);
          this.dialogMsg.msg = '匯入成功';
        } else if (res.data != null && res.data.status == 'failed') {
          this.dialogMsg.msg = `錯誤, ${JSON.stringify(res.data.error)}`;
        }
        this.dialogMsg.btnTxt = '好';
        this.dialogMsg.isShow = true;
        //clear file
        document.getElementById('fileMachine').value = '';
      });
    },
    ShowEditVcmsTime(currentTime) {
      this.isEditVcmsTime = true;
      this.vcmsTime = currentTime;
    },
    CloseEditVcmsTime() {
      this.isEditVcmsTime = false;
    },
    EditVcmsTime() {
      let data = {
        Account: this.accountData.info.account,
        VCMS: this.vcmsTime,
      };
      apiUpdateVcmsTime(data).then((res) => {
        if (res.data.status == 'ok') {
          this.accountData.info.vcmstime = this.vcmsTime;
          this.$toasted.show(`已修改`, {
            icon: 'check',
            position: 'bottom-center',
            duration: 2500,
          });
          this.CloseEditVcmsTime();
        } else {
          this.$toasted.show(`錯誤, ${JSON.stringify(res.data)}`, {
            icon: 'warning',
            position: 'bottom-center',
            duration: 2500,
          });
        }
      });
    },
    DownloadMachineExample() {
      let url = 'https://surreal-edu.s3.ap-northeast-1.amazonaws.com/ImportMachine.xlsx';
      window.open(url);
    },
  },
  components: {
    datepicker,
    DialogTwoBtn,
    DialogAddLecture,
    DialogOneBtn,
    Loading,
  },
};
</script>